import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import { useParams } from 'react-router-dom';
import { Icon } from '@components/icons';
import { useBack } from '@hooks/helpers/useBack';
import { useAgreements } from '@hooks/api/useAgreement';
import Button from '@components/common/button';
import { useQueryParams } from '@hooks/helpers/useQueryParams';
import MDEditor from '@uiw/react-md-editor';
import useModalContext from '@hooks/context/useModalContext';
import { modalIds } from '@const/modals';
import { TCreateDocument } from '@xeppt/xeppt-sdk/types';

const AgreementLayout = () => {
    const { id } = useParams<{ id: string }>();
    const [isTemplate] = useQueryParams(['template']);
    const { handleNavigateBack } = useBack();
    const [value, setValue] = useState('**Hello world!!!**');
    const { onOpen, onClose } = useModalContext();

    const {
        agreement,
        handleCreateDocument,
        handleSetAsPrimary,
        isCreateDocumentLoading,
        isSetAsPrimaryDocumentLoading
    } = useAgreements({
        isInitialAgreement: true,
        agreementId: id
    });

    const handleOpenSaveModal = () => {
        onOpen({
            modalId: modalIds.SAVE_AGREEMENT,
            onSubmit: (data: Omit<TCreateDocument, 'name' | 'content'>) => {
                handleCreateDocument({ ...data, content: value });
                onClose();
            }
        });
    };

    console.log({ agreement });

    useEffect(() => {
        setValue(agreement?.content || '');
    }, [agreement]);

    return (
        <div className={styles.wrapper}>
            <button onClick={handleNavigateBack} className="back">
                <Icon name="arrow_left" width={16} height={16} />
                Back
            </button>
            <div className={styles.header}>
                <div className={styles.text_wrapper}>
                    <Typography variant="h4">
                        {isTemplate ? 'New cardholder agreement' : `Version ${agreement?.version}`}
                    </Typography>
                </div>
                {isTemplate && id ? (
                    <Button
                        variant="primary"
                        size="normal"
                        onClick={handleOpenSaveModal}
                        isLoading={isCreateDocumentLoading}>
                        Save as new version
                    </Button>
                ) : (
                    <Button
                        variant="primary"
                        size="normal"
                        onClick={() => handleSetAsPrimary(id || '')}
                        isLoading={isSetAsPrimaryDocumentLoading}>
                        Set as primary
                    </Button>
                )}
            </div>
            <div data-color-mode="light">
                <MDEditor
                    className={styles.editor}
                    value={value}
                    aria-readonly={true}
                    onChange={(val) => isTemplate && setValue(val || '')}
                />
            </div>
        </div>
    );
};

export default AgreementLayout;
